import { SimpleChanges, Renderer2, ElementRef, Injector, Type } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IInputOptions {
  isBoolean?: boolean;
  prefix?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IInputsClassesConfig {
  [input: string]: IInputOptions;
}

export class BindHostClasses {
  private renderer: Renderer2;
  private elementRef: ElementRef<HTMLElement>;

  constructor(private injector: Injector, private inputs: IInputsClassesConfig) {
    this.renderer = this.injector.get(Renderer2);
    this.elementRef = this.injector.get(ElementRef);
  }

  onInit(component: InstanceType<Type<Object>>): void {
    Object.keys(this.inputs).forEach(input => {
      const value = component[input];

      if (value === undefined) {
        return;
      }

      this.toggleClass(input, value, true);
    });
  }

  onUpdate(changes: SimpleChanges): void {
    Object.keys(this.inputs).forEach(input => {
      if (!changes[input]) {
        return;
      }

      this.toggleClass(input, changes[input].previousValue, false);
      this.toggleClass(input, changes[input].currentValue, true);
    });
  }

  private toggleClass(input: string, value: unknown, addClass: boolean): void {
    if (value === undefined) {
      return;
    }

    const inputOptions = this.inputs[input];
    const className = this.getClassForInput(input, value, inputOptions);

    if (inputOptions.isBoolean && value === false) {
      addClass = false;
    }

    if (addClass) {
      this.renderer.addClass(this.elementRef.nativeElement, className);
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, className);
    }
  }

  private getClassForInput(input: string, value: unknown, inputOptions: IInputOptions): string {
    const prefix = inputOptions.prefix ? `-${inputOptions.prefix}` : '';

    let className = inputOptions.isBoolean ? input : value;
    className = this.formatClassName(className as string);

    return `${prefix}-${className}`;
  }

  private formatClassName(className: string): string {
    return className.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}
